<template>
  <div class="password-setting">
    <v-header>密碼設置</v-header>
    <h4 class="setting-tips">
      為了您的賬戶安全，設置密碼前
      <span class="break-line">
        <br />
      </span>
      請完成以下驗證
    </h4>
    <authentication class="authen-content"></authentication>
    <pl-tips v-if="showTips" @close="showTips = false"></pl-tips>
  </div>
</template>

<script>
import PlTips from '@/components/pl-tips'
import vHeader from '@/components/header'
import authentication from '@/components/authentication'
export default {
  name: 'PasswordSetting',
  components: { vHeader, authentication, PlTips },
  data () {
    return {
      showTips: false
    }
  },
  mounted () {
    this.$store.commit('setLoadingState', false)
  }
}
</script>

<style lang="scss" scoped>
.password-setting {
  height: 100%;
  background: #f4f4f4;
  h4 {
    color: #333;
  }
  .authen-content {
    margin: 0 auto;
  }
}
@media screen and (orientation: landscape) {
  .setting-tips {
    margin: 10px 0;
  }
  .break-line {
    display: none;
  }
}
</style>
